import styled, { css } from 'styled-components'
import { Col, Colors, Utils } from '@microfrontends/react-components'

export const CompanySearchHeaderWrapper = styled.div`
    h1 {
        color: #002c55;
        font-size: 40px;
        font-weight: 700;
        margin-bottom: 8px;
        @media screen and (max-width: ${Utils.screens.tablet}px) {
            font-size: 19px;
            text-align: center;
        }
    }
    p {
        color: #002c55;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 24px;
    }
    > div {
        > div {
            margin: 0;
            > div {
                margin-top: 0;
            }
        }
    }
    @media screen and (max-width: 768px) {
        width: 100%;
        p {
            display: none;
        }
    }
`

export const SearchCompany = styled.div`
    width: 70%;
    background-color: #e6efff;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 8px;
    @media (max-width: 768px) {
        width: 100%;
    }
`

export const InputWrapper = styled(Col)<{ isFocus: boolean }>`
    display: flex;
    align-items: center;
    border: 1px solid #a2a6ac;
    background-color: #fff;
    border-radius: 6px;
    padding-left: 10px;
    height: 40px;
    padding-right: 0;
    > div {
        width: 100%;
    }
    input {
        width: 100%;
        border: none !important;
        background-color: transparent !important;
    }
    &:hover {
        border: 1px solid ${Colors.borderHover};
        box-shadow: none;
        background-color: #fff;
        input {
            padding-right: 36px !important;
        }
    }
    ${({ isFocus }) => {
        if (!isFocus) {
            return ''
        }
        return css`
            border-color: ${Colors.borderFocus};
            input {
                padding-right: 36px !important;
            }
        `
    }}
`

export const ButtonWrapper = styled(Col)``
